// GLOBAL JS
$(function () {
  console.log('global.js loaded');
});
